import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slice/user';
import { SocketConnect, getSocket } from '../../socket';
import { useAuth } from '@clerk/clerk-react';
import { registerPushToken } from '../../utils/pushSetup';
import { addNotification, selectUnreadCount, setCount, setNotifications } from '../../redux/slice/notificationSlice';
import { CallWithAuth } from '../../actions/apiAction';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import FloatingNotificationStack from '../../components/Notification/FloatingNotification';
import Cookie from '../../utils/Cookie';
import { FB_CONFIG } from '../../firebaseConfig.generated';

// const location = useLocation()


const MainLayout = ({ children }) => {
  const { isInitialized } = useSelector(state => state.socketSlice);
  const dispatch = useDispatch();
  const [showLeftMenue, setShowLeftMenue] = useState(false)
  const [showAccountMenu, setShowAccountMenu] = useState(false)
  const navigator = useNavigate();
  const location = useLocation();
  const { getToken, isSignedIn } = useAuth();
  const [floatingNotifications, setFloatingNotifications] = useState([]);
  const navigate = useNavigate();
  const totalUnreadNotification = useSelector(selectUnreadCount);


  const removeFloating = (id) => {
    setFloatingNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const handleFloatingClick = (n) => {
    removeFloating(n.id);
    if (n.data?.creator_id) {
      const isPwaReminder =
        n.data?.type === 'pwa_install_reminder' || n.data?.show_pwa_tip === 'true';
      const base = `/user/chat?id=${encodeURIComponent(n.data.creator_id)}`;
      navigate(isPwaReminder ? `${base}&show_pwa_tip=1` : base);
    }
  };


  useEffect(() => {
    const fetchNotifications = async () => {
      if (!isSignedIn) return;
      try {
        const res = await CallWithAuth('GET', '/notifications/' + '?skip=0&limit=20');
        const chatRes = await CallWithAuth('GET', '/chats/');
        if (chatRes?.data && res?.data) {
          const unread_count = chatRes?.data?.reduce((acc, n) => acc + n.unread_count, 0);
          const newdata = {
            ...res.data,
            unread_count
          }
          console.log('new unread count', newdata)
          dispatch(setNotifications(newdata));
          dispatch(setCount(newdata?.unread_count));
          window.navigator.setAppBadge(unread_count)
        }
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
      }
    };

    // Guests have no notification inbox. Chat still loads on its own.
    if (isSignedIn) fetchNotifications();

    // re-fetch when app comes back into focus (e.g. minimized -> reopened)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchNotifications();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', fetchNotifications);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', fetchNotifications);
    };
  }, [isSignedIn]);
  const fetchToken = async () => {
    try {
      const token = await getToken({ template: "TLK" });
      return token;
    } catch (err) {
      return null;
    }
  };

  useEffect(() => {
    console.log('current socket status', isInitialized)
    // Rebuild only when the module reference is gone. Unexpected drops now null the socket
    // and disable orphaned auto-reconnect; a second connect while one still exists would race.
    if (isSignedIn && isInitialized == 'disconnected' && getSocket() === null) {
      SocketConnect(() => fetchToken());
    }
  }, [isInitialized]);
  const goToProfile = () => {
    console.log('Enrwechhsddh')
    navigator('/user/account');
  };

  const goToEditProfile = () => {
    navigator('/user/edit-profile');
  }
  const goToChangePassword = () => {
    navigator('/user/change-password');
  }

  const goToHelp = () => {
    navigator('/user/help');
  }
  const handleLogout = () => {
    dispatch(logout())
    navigator('/login')
  }

  useEffect(() => {
    const app = initializeApp(FB_CONFIG);
    const messaging = getMessaging(app);
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      const title = payload.notification?.title || "New message";
      const body = payload.notification?.body || "";
      const id = payload.data?.message_id || Date.now();
      const badge = payload.data?.badge || 1;
      // toast(`${title}: ${body}`);
      dispatch(addNotification({
        id, // or whatever unique id the backend sends
        type: payload.data?.type,
        title,
        body,
        data: payload.data,
        badge,
        read_at: null,
        created_at: new Date().toISOString(),
      }));
      dispatch(setCount(badge));
      setFloatingNotifications((prev) => [...prev, { id, title, body, data: payload.data, duration: 5000 }]);
      window.navigator.setAppBadge(badge)
      // auto-dismiss after duration
      setTimeout(() => removeFloating(id), 5000);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let isOnbordingShown = Cookie.getCookie('isOnbordingShown');

    if (!isOnbordingShown && isSignedIn) {
      Cookie.setCookie('isOnbordingShown', 'true', 360);
    }
  }, [isSignedIn])

  return (
    <>
      <FloatingNotificationStack
        notifications={floatingNotifications}
        onDismiss={removeFloating}
        onClick={handleFloatingClick}
      />
      {children}
    </>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
